import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { lastValueFrom, map } from 'rxjs';
import { Usuario } from '../models/usuario.model';
import { Restaurante } from '../models/restaurante.model';
import { Socket } from 'ngx-socket-io';
import { extend } from 'jquery';
import { FiltroLista } from '../models/filtro-lista.model';

@Injectable({
  providedIn: 'root',
})
export class RestauranteService {
  constructor(private http: HttpClient, public socket: Socket) {}

  progressoImportadorRestaurantes = this.socket.fromEvent(
    'progressoImportadorRestaurantes'
  );

  async incluirFilaCriacao(body: any): Promise<Restaurante[]> {
    return await lastValueFrom(
      this.http.post<Restaurante[]>(
        `${environment.apiUrl}/restaurantes/incluir-fila-criacao`,
        body
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async criar(restaurante: Restaurante): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.post<Restaurante>(
        `${environment.apiUrl}/restaurantes`,
        restaurante
      )
    ).catch((err) => {
      throw Error(err);
    });
  }
  async criarImagemGaleria(imagemGaleria: any): Promise<any> {
    return await lastValueFrom(
      this.http.post<any>(
        `${environment.apiUrl}/restaurantes/imagem-galeria`,
        imagemGaleria
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async atualizarImagemGaleria(id: string, imagemGaleria: any): Promise<any> {
    return await lastValueFrom(
      this.http.patch<any>(
        `${environment.apiUrl}/restaurantes/imagem-galeria/${id}`,
        imagemGaleria
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async atualizarOrdemImagemGaleria(imagensGaleria: any): Promise<any> {
    return await lastValueFrom(
      this.http.post<any>(
        `${environment.apiUrl}/restaurantes/imagem-galeria-ordem`,
        imagensGaleria
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async buscarTodosAtivos(): Promise<Restaurante[]> {
    return await lastValueFrom(
      this.http.get<Restaurante[]>(`${environment.apiUrl}/restaurantes/ativos`)
    ).catch((err) => {
      throw Error(err);
    });
  }


  async buscarTodosMunicipiosAtivos(municipio: string): Promise<Restaurante[]> {
    return await lastValueFrom(
      this.http.get<Restaurante[]>(`${environment.apiUrl}/restaurantes/municipios-ativos/${municipio}`)
    ).catch((err) => {
      throw err.error.message;
    });
  }

  async atualizar(restaurante: Restaurante | any): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.patch<Restaurante>(
        `${environment.apiUrl}/restaurantes/${restaurante.id}`,
        restaurante
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async listar(body: FiltroLista): Promise<any[]> {
    return await lastValueFrom(
      this.http.post<any[]>(`${environment.apiUrl}/restaurantes/listar`, body)
    ).catch((err: any) => {
      throw err.error.message;
    });
  }

  async buscarRestauranteAptos(): Promise<Restaurante[]> {
    return await lastValueFrom(
      this.http.get<Restaurante[]>(`${environment.apiUrl}/restaurantes/aptos`)
    ).catch((err) => {
      throw Error(err);
    });
  }

  async buscarRestaurantePorId(id: string): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.get<Restaurante>(`${environment.apiUrl}/restaurantes/${id}`)
    ).catch((err) => {
      throw Error(err);
    });
  }
  async buscarGaleria(id: string): Promise<any> {
    return await lastValueFrom(
      this.http.get<Restaurante>(
        `${environment.apiUrl}/restaurantes/buscar-galeria/${id}`
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async buscarInformacoesBaseRestaurante(id: string): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.get<Restaurante>(
        `${environment.apiUrl}/restaurantes/informacoes-base/${id}`
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async buscarRestauranteComPratos(id: string): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.get<Restaurante>(
        `${environment.apiUrl}/restaurantes/com-pratos/${id}`
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async buscarTodos(): Promise<Restaurante[]> {
    return await lastValueFrom(
      this.http.get<Restaurante[]>(`${environment.apiUrl}/restaurantes`)
    ).catch((err) => {
      throw Error(err);
    });
  }

  async buscarRestaurantePorNomeFantasia(
    nomeFantasia: string
  ): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.post<Restaurante>(
        `${environment.apiUrl}/restaurantes/por-nome-fantasia`,
        { nomeFantasia }
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async vincularUsuario(restauranteId: string, usuario: any) {
    return await lastValueFrom(
      this.http.patch<Restaurante>(
        `${environment.apiUrl}/restaurantes/${restauranteId}/vincular-usuario`,
        usuario
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async desvincularUsuario(restauranteId: string, usuario: any) {
    return await lastValueFrom(
      this.http.patch<Restaurante>(
        `${environment.apiUrl}/restaurantes/${restauranteId}/desvincular-usuario`,
        usuario
      )
    ).catch((err) => {
      throw Error(err);
    });
  }

  async ativar(id: string): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.patch<Restaurante>(
        `${environment.apiUrl}/restaurantes/ativar/${id}`,
        {}
      )
    ).catch((err) => {
      throw err.error.error;
    });
  }

  async desativar(id: string): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.patch<Restaurante>(
        `${environment.apiUrl}/restaurantes/desativar/${id}`,
        {}
      )
    ).catch((err) => {
      throw err.error.error;
    });
  }

  async remover(id: string): Promise<Restaurante> {
    return await lastValueFrom(
      this.http.delete<Restaurante>(`${environment.apiUrl}/restaurantes/${id}`)
    ).catch((err) => {
      throw err.error.error;
    });
  }

  async adicionarImagemGaleria(
    idRestaurante: string,
    imagem: string
  ): Promise<{ urlImagem: string }> {
    return await lastValueFrom(
      this.http.patch<{ urlImagem: string }>(
        `${environment.apiUrl}/restaurantes/adicionar-imagem-galeria/${idRestaurante}`,
        { imagem }
      )
    ).catch((err) => {
      throw err.error.error;
    });
  }

  async removerImagemGaleria(idImagemGaleria: string): Promise<void> {
    await lastValueFrom(
      this.http.delete<any>(
        `${environment.apiUrl}/restaurantes/remover-imagem-galeria/${idImagemGaleria}`
      )
    ).catch((err) => {
      throw err.error.error;
    });
  }

  async buscarTagsAi(id: string): Promise<any> {
    return await lastValueFrom(
      this.http.get<any>(`${environment.apiUrl}/restaurantes/buscar-tags-ai/${id}`)
    ).catch((err) => {
      throw err.error.error;
    });
  }

}
